import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=6948733e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6948733e')) {
      api.createRecord('6948733e', component.options)
    } else {
      api.reload('6948733e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=6948733e&", function () {
      api.rerender('6948733e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fswtg47njH3X/JS/videoIframe.vue"
export default component.exports